module.exports = __webpack_public_path__ + "564e19cc0fdb2ef34f3e5d78f0714dd4.svg";